import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { toggleCustomInlineStyle } from 'draftjs-utils';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import styled from 'src/ui/library/styled';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'; // ~20KB brought in
import { convertToRaw } from 'draft-js';

const styles = (theme, props) => ({
  mainWrapper: {
    height: 'inherit',
  },
  editWrapper: {
    lineHeight: '22px',
    padding: '0px 16px 16px 16px',
  },
  '@global': {
    '.rdw-editor-main blockquote': {
      borderLeft: `solid 3px ${theme.colors.eyGrey9}`,
      padding: '0px',
      margin: '16px 0px 0px 0px',
    },
  },
});

class RichTextEditorBase extends React.Component {
  static propTypes = {
    /** Classname to be applied to <RichTextEditor> */
    className: PropTypes.string,
    /** Passed in data for uncontrolled component RichTextEditor */
    defaultValue: PropTypes.string,
    /** If `true`, the input will auto focus */
    autoFocus: PropTypes.bool,
    /** If `true`, the input will not have an underline. */
    onTextChange: PropTypes.func,
  };

  state = {
    editorState: '',
  };

  componentDidMount() {
    const { defaultValue } = this.props;
    let editorBtns = document.querySelectorAll('.rdw-option-wrapper:not(.rdw-option-disabled), .rdw-dropdown-wrapper');
    editorBtns.forEach((btn, index) => {
      this[index] = btn.setAttribute('tabindex', '0');
    }, editorBtns);
    if (defaultValue) {
      const contentBlock = htmlToDraft(defaultValue);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        this.setState({ editorState }, () => this.focusEditor());
      }
    } else {
      this.focusEditor();
    }
  }

  focusEditor = () => {
    if (this.editorRef && this.props.autoFocus) {
      const { defaultValue } = this.props;
      let editorBtns = document.querySelectorAll('.rdw-option-wrapper:not(.rdw-option-disabled), .rdw-dropdown-wrapper');
      editorBtns.forEach((btn, index) => {
        this[index] = btn.setAttribute('tabindex', '0');
      }, editorBtns);
      if (defaultValue) {
        const contentBlock = htmlToDraft(defaultValue);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          const editorState = EditorState.createWithContent(contentState);
          this.setState({ editorState }, () => {
            if (this.editorRef) {
              this.editorRef.focus();
            }
          });
        }
      }

      // this.editorRef.focus();
    }
  };

  onEditorStateChange = editorState => {
    this.setState(
      {
        editorState,
      },
      () => {
        const rawContent = convertToRaw(editorState.getCurrentContent());
        const html = draftToHtml(rawContent);
        if (this.props.onTextChange) this.props.onTextChange(html);
      },
    );
  };

  // This is a POC function incase we need to create a toolbar that exists
  // outside of the current toolbar. Think floating toolbar or single FAB that
  // triggers toolbar functionality
  incFont = () => {
    const newState = toggleCustomInlineStyle(this.state.editorState, 'fontSize', 27);
    this.onEditorStateChange(newState);
  };

  render() {
    const { editorState } = this.state;
    const { className, styleType, data, classes, ...otherProps } = this.props;

    const defaultClass = className || 'richtext-root';
    const rootClass = classNames(defaultClass, styleType);

    return (
      <div className={rootClass}>
        <Editor
          spellCheck
          editorState={editorState}
          editorRef={el => (this.editorRef = el)}
          wrapperClassName={classes.mainWrapper}
          editorClassName={classes.editWrapper}
          onEditorStateChange={this.onEditorStateChange}
          handlePastedText={() => false}
          toolbar={{
            options: ['inline', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link'],
            inline: {
              inDropdown: false,
              options: ['bold', 'italic', 'underline', 'strikethrough'],
            },
            link: {
              inDropDown: false,
              options: ['link'],
            },
          }}
          {...otherProps}
        />
      </div>
    );
  }
}

export { RichTextEditorBase };
export default styled(RichTextEditorBase)(styles);
